//This file gets renamed to `app.config.ts` during the github workflow maintenance page action. Then the values in this file will affect app.vue and [...slug].vue
export default defineAppConfig({
	showMaintenancePage: true,
})
